import { useState } from 'react';
export function useCombatMapModal() {
    const [isShowModal, setIsShowModal] = useState(false);
    const [combatMaps, setCombatMaps] = useState([]);
    const [isLoadingCombatMaps, setLoadingCombatMaps] = useState(false);
    const openModal = (fetchMaps) => {
        setIsShowModal(true);
        if (combatMaps.length === 0)
            setLoadingCombatMaps(true);
        const promise = fetchMaps()
            .then((maps) => {
            setCombatMaps(maps);
        })
            .catch((err) => {
            console.error('[useCombatMapModal] failed to fetch combat maps', err);
        })
            .finally(() => {
            setLoadingCombatMaps(false);
        });
        return promise;
    };
    const closeModal = () => setIsShowModal(false);
    return {
        isShowModal,
        setIsShowModal,
        isLoadingCombatMaps,
        setLoadingCombatMaps,
        openModal,
        closeModal,
        combatMaps,
        setCombatMaps,
    };
}
